// Removes every cart line of a bundle at once, then refreshes the cart drawer (or reloads the cart page)
if (!customElements.get('bundle-remove-button')) {
  customElements.define(
    'bundle-remove-button',
    class BundleRemoveButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', () => this.remove());
      }

      async remove() {
        const keys = (this.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
        const inDrawer = Boolean(this.closest('cart-drawer'));
        const updates = Object.fromEntries(keys.map((key) => [key, 0]));

        try {
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates,
              sections: inDrawer ? 'cart-drawer,cart-icon-bubble' : undefined,
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-remove', cartData: state });
          }

          if (inDrawer && drawer && state.sections) {
            drawer.renderContents({ sections: state.sections });
            drawer.classList.toggle('is-empty', state.item_count === 0);
          } else {
            window.location.reload();
          }
        } catch (error) {
          window.location.reload();
        }
      }
    }
  );
}
